module.exports = __webpack_public_path__ + "static/img/nav_bg_fix.1cc9473b.png";